import { icons } from "utils/constants";
import { getUserType } from "utils/helpers";
import Button from "../../form/Button";
import Modal from "../Modal";
import "./MembershipSuccessPopup.scss";

export const IFERP_LINKEDIN_URL = "https://www.linkedin.com/groups/19049029/";

// Shown once a membership payment is completed and saved (Issue #597).
// Navigation uses a full page load so the dashboard picks up the new plan.
const MembershipSuccessPopup = ({ onClose }) => {
  const memberType = getUserType();
  const goTo = (path) => {
    window.location.assign(path);
  };

  return (
    <Modal onHide={onClose} size="md" width="100%">
      <div className="text-center" id="membership-success-popup-container">
        <div className="header-icon">
          <img src={icons.successTick} alt="success" />
        </div>
        <div className="text-24-600 color-raisin-black cmt-20">
          🎉 Thank You for Choosing IFERP!
        </div>
        <div className="text-16-400 color-black-olive cmt-10">
          Your membership has been successfully activated.
          <br />
          Welcome to the IFERP Research Community!
        </div>

        <div className="success-section">
          <div className="text-15-400 color-black-olive cmb-16">
            Complete your profile to personalize your membership experience
            and unlock access to all member services and opportunities.
          </div>
          <Button
            isRounded
            text="Complete My Profile"
            btnStyle="primary-dark"
            className="cps-30 cpe-30"
            onClick={() => goTo(`/${memberType}/complete-profile`)}
          />
        </div>

        <div className="success-section">
          <div className="text-15-400 color-black-olive cmb-16">
            Explore the exclusive benefits included with your membership.
          </div>
          <Button
            isRounded
            text="Get to know your benefits"
            btnStyle="purple-bg"
            className="cps-30 cpe-30"
            onClick={() => goTo(`/${memberType}/my-profile/my-membership`)}
          />
        </div>

        <div className="success-section">
          <div className="text-15-400 color-black-olive cmb-16">
            Join our official LinkedIn community to connect with researchers,
            academicians, industry experts, and students worldwide. Stay
            updated on conferences, webinars, publication opportunities,
            research discussions, and academic collaborations.
          </div>
          <Button
            isRounded
            text="Join Our LinkedIn Community"
            btnStyle="primary-outline"
            className="cps-30 cpe-30"
            icon={<i className="bi bi-linkedin me-2" />}
            onClick={() => {
              window.open(IFERP_LINKEDIN_URL, "_blank", "noopener,noreferrer");
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
export default MembershipSuccessPopup;
